import { GroupView } from '@views/GroupView';
import actionResponse, { ActionResponse } from '../../ActionResponse';
import { GroupStore } from '@stores/GroupStore';
import { describeGroupSaveFailure, describeGroupSaveSuccess } from './GroupSaveMessage';

export class CreateGroupAction {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  // On a save, result.saveResult is what the admin is shown, whether the save worked or not
  async Execute(reason: 'SAVE' | string, selectedGroup: GroupView): Promise<ActionResponse> {
    if (reason !== 'SAVE') {
      return actionResponse.Success('CreateGroupAction.execute done');
    }

    const response = await this.store.Write(selectedGroup);
    if (response.status === 'SUCCESS' && response.statusCode < 400) {
      const saveResult = describeGroupSaveSuccess(selectedGroup.name, 'created', response.result?.summary);
      return actionResponse.Success(saveResult.message, { group: response.result, saveResult });
    }
    const saveResult = describeGroupSaveFailure(selectedGroup.name, 'created', response);
    return { ...actionResponse.Error(saveResult.message), result: { saveResult } };
  }
}
